import { createSvgIcon } from '@mui/material';

export const ExitSvgIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M16.68 15.4286L20 12M20 12L16.68 8.57143M20 12H9.71428M16.5714 4L7.42857 4.00229C6.16685 4.00343 5.14285 5.02629 5.14285 6.288V17.7109C5.14285 18.3171 5.38367 18.8984 5.81232 19.3271C6.24098 19.7558 6.82236 19.9966 7.42857 19.9966H16.68" strokeWidth="1.52381" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'BellAlt'
)